import {
  NotificationChannel,
  type ModelUserNotificationSettings,
} from '@app/api/Notifications';

// Свич «Отображение всплывающих уведомлений» в окне «Уведомления» —
// это агрегат над матрицей настроек (ModelUserNotificationSettings.Items)
// по каналу in-app (тосты + колокольчик). Отдельной матрицы в UI пока
// нет: один тумблер включает/выключает in-app-канал целиком.

const isInAppItem = (channel: NotificationChannel): boolean =>
  channel === NotificationChannel.InApp;

// Свич включён, если хоть одно in-app-событие включено (трактовка
// «глобальное отключение»: выкл = не показывать ничего). Пустой список
// или его отсутствие — тоже «включено» (дефолт бэка — true).
export const selectPopupNotificationsEnabled = (
  settings: ModelUserNotificationSettings | undefined
): boolean => {
  const inAppItems = (settings?.Items ?? []).filter((item) =>
    isInAppItem(item.Channel)
  );

  return inAppItems.length === 0
    ? true
    : inAppItems.some((item) => item.IsEnabled);
};

// Готовит тело для UpdateNotificationSettings: переключает IsEnabled у всех
// in-app-событий, остальные каналы не трогает.
export const applyPopupNotificationsEnabled = (
  settings: ModelUserNotificationSettings,
  isEnabled: boolean
): ModelUserNotificationSettings => ({
  ...settings,
  Items: (settings.Items ?? []).map((item) =>
    isInAppItem(item.Channel) ? { ...item, IsEnabled: isEnabled } : item
  ),
});
